exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".LX__icon__self {\n  font-size: 0.8em;\n  line-height: 0.8em;\n}\n", "", {"version":3,"sources":["/apps/packages/components/src/icon.scss"],"names":[],"mappings":"AAAA;EACE,iBAAgB;EAChB,mBAAkB;CACnB","file":"icon.scss","sourcesContent":[".self {\n  font-size: 0.8em;\n  line-height: 0.8em;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"self": "LX__icon__self"
};